<template>
  <v-subheader
    class="text-uppercase grey--text grey lighten-5"
    :class="disabled ? 'text--lighten-1' : 'text--darken-1'"
  >
    <slot />
  </v-subheader>
</template>

<script>
  export default {
    props: {
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
  }
</script>
